/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

const keyMap = {
  id: 'id',
  'Nome completo do paciente': 'fullname',
  'Data de nascimento': 'birthdate',
  Email: 'email',
  CPF: 'documentId',
  Telefone: 'phoneNumber',
  Gênero: 'gender',
  'Nome completo da mãe': 'mothersName',
  'Nome completo do responsável': 'responsible',
  'Característica do paciente': 'patientType',
  País: 'country',
  Estado: 'state',
  Cidade: 'city',
  CEP: 'zipCode',
  Rua: 'street',
  Número: 'houseNumber',
  Complemento: 'unitNumber',
  Bairro: 'neighborhood',
};

export const convertKeys = (item) => Object.keys(keyMap).reduce((prev, cur) => {
  if (item[cur] === undefined) {
    item[cur] = '';
  }
  return Object.assign(prev, { [keyMap[cur]]: item[cur] });
}, {});

export const getAddress = (item) => ({
  country: item.country,
  state: item.state,
  city: item.city,
  zipCode: item.zipCode,
  street: item.street,
  houseNumber: item.houseNumber,
  unitNumber: item.unitNumber,
  neighborhood: item.neighborhood,
  createdAt: item.createdAt,
});

export const removeAddress = (item) => {
  delete item.country;
  delete item.state;
  delete item.city;
  delete item.zipCode;
  delete item.street;
  delete item.houseNumber;
  delete item.unitNumber;
  delete item.neighborhood;
  return item;
};
